import React, {Component} from 'react';

import XXLFunctionsText from 'components/XXL/XXLFunctionsText';

import 'sass/xxl-functions.scss';

class XXLFunctions extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <aside className="block-fonctions-xxl">
                <XXLFunctionsText className="text"/>
            </aside>
        )
    }
}

export default XXLFunctions;


// WEBPACK FOOTER //
// ./src/components/index/XXLFunctions.js